<template>
  <manage-ticket
    :application="deTicketApplications.FINANZAS"
    :modules="modules"
    :on-download="onDownloadHandler"
    :read-only="readOnly"
    :reference-number-types="referenceNumberTypes"
    :save-ticket="saveUserCase"
    :ticket-data="ticketData"
    :user="fullProfile"
    :validate-reference-number="validateReferenceNumber"
    @update-references="fetchReferenceNumberTypes"
  />
</template>

<script>
import { ManageTicket } from 'support-tickets';
import {
  getUserCaseById,
  getUserCaseReferenceNumberTypes,
  saveUserCase as _saveUserCase,
  downloadDocument,
  getPreviousContactInformation,
  validateReferenceNumber as _validateReferenceNumber,
} from '@/modules/helpdesk/api.js';
import service from '@/modules/app/api';
import deTicketApplications from '@/utils/constants/deTicketApplications.js';
import { name as userModuleName } from '@/modules/user/store';
import { mapGetters, mapState } from 'vuex';
import { serialize as objectToFormData } from 'object-to-formdata';

const initialModel = () => ({
  itemId: null,
  description: null,
  documents: [
    {
      tempId: 1,
      id: null,
      data: null,
      name: null,
    },
  ],
  module: null,
  screen: null,
  referenceNumberTypes: [],
  email: null,
  telephone1: null,
  telephone2: null,
  statusId: null,
  workflowId: null,
  userContactInformation: {},
});

export default {
  name: 'CreateTicket',
  components: { ManageTicket },
  data() {
    return {
      deTicketApplications,
      ticketData: initialModel(),
      readOnly: false,
      referenceNumberTypes: [],
    };
  },
  computed: {
    ...mapGetters(userModuleName, ['fullProfile']),
    ...mapState(userModuleName, ['userMenu']),
    modules() {
      return this.userMenu.map((m) => ({
        id: m.id,
        name: m.title,
        screens: m.children.map((item) => ({
          id: item.id,
          name: item.title,
        })),
      }));
    },
  },
  async mounted() {
    const { id } = this.$route.params;
    await this.fetchReferenceNumberTypes();
    if (id) {
      const { data } = await getUserCaseById(id);
      this.ticketData = {
        ...data,
        documents: data.documents ?? [],
      };
      this.readOnly = true;
    } else {
      const contactInfo = await this.getPreviousContactInfo();
      this.ticketData.userContactInformation = contactInfo;
    }
  },
  methods: {
    async fetchReferenceNumberTypes(params) {
      const { data } = await getUserCaseReferenceNumberTypes(params);
      this.referenceNumberTypes = [...data];
    },
    saveUserCase(data) {
      const formData = objectToFormData(data, {
        indices: true,
        nullsAsUndefineds: true,
      });

      const files = data?.files ?? [];
      if (files.length) {
        files.forEach((file) => {
          formData.append('files', file);
        });
      }

      return _saveUserCase(formData);
    },
    validateReferenceNumber(reference, referenceType) {
      return _validateReferenceNumber(reference, referenceType);
    },
    async onDownloadHandler(fileId) {
      if (fileId) {
        await downloadDocument(fileId);
      } else {
        let file = {
          filename: document.filename,
          content: document.file,
          contentType: 'application/pdf',
        };
        service.downloadFile(file);
      }
    },
    async getPreviousContactInfo() {
      const { data } = await getPreviousContactInformation();
      return data;
    },
  },
};
</script>
